import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/pro-regular-svg-icons';
import {
  Button, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core';
import sanitizeHtml from 'sanitize-html';
import { translate } from 'utils/translation';

const ErrorModal = ({
  onClose, afterClose, text, title
}) => {
  const handleClose = useCallback(() => {
    onClose();
    afterClose && afterClose();
  }, [onClose, afterClose]);

  return (
    <>
      <DialogTitle className="errorModal">
        <FontAwesomeIcon icon={faTimes} />
        {translate(title)}
      </DialogTitle>

      <DialogContent dangerouslySetInnerHTML={{ __html: sanitizeHtml(text) }} />

      <DialogActions>
        <Button color="primary" onClick={handleClose}>
          {translate('button.close')}
        </Button>
      </DialogActions>
    </>
  );
};

ErrorModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  afterClose: PropTypes.func,
  text: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({})
  ]),
  title: PropTypes.string
};

ErrorModal.defaultProps = {
  afterClose: null,
  text: '',
  title: 'errors.error'
};

export default ErrorModal;